
import { defineComponent } from '@nuxtjs/composition-api'
import { appColors } from '~/assets/tailwind'

export default defineComponent({
  props: {
    svgTheme: {
      type: String,
      required: false,
      default: 'dark-green',
      validator: (value) => ['blue', 'pink', 'dark-green', 'red'].includes(value),
    },
  },
  setup(props) {
    const themes = [
      {
        title: 'blue',
        startColor: appColors['secondary-9-blue--turquoise'],
        endColor: appColors['secondary-9-blue--iris'],
        x1: '11.12%',
        y1: '0%',
        x2: '52.48%',
        gradientTransform: 'rotate(-30)',
      },
      {
        title: 'pink',
        startColor: appColors['secondary-3-orange--atomic-tangerine'],
        endColor: appColors['secondary-6-red--azalea'],
        x1: '12.98%',
        y1: '0%',
        x2: '46.88%',
        gradientTransform: 'rotate(-29)',
      },
      {
        title: 'dark-green',
        startColor: appColors['secondary-9-green--sherpa-blue'],
        endColor: appColors['secondary-8-blue--medium-aquamarine'],
        x1: '11.12%',
        y1: '0%',
        x2: '52.48%',
        gradientTransform: 'rotate(-30)',
      },
      {
        title: 'red',
        startColor: appColors['primary-1-red--torch'],
        endColor: appColors['primary-1-red--fire-brick'],
        x1: '19.19%',
        y1: '0%',
        x2: '45.32%',
        gradientTransform: 'rotate(-10)',
      },
      {
        title: 'ocher-yellow',
        startColor: appColors['secondary-2-yellow--saffron'],
        endColor: appColors['secondary-2-yellow--dark-portica'],
        x1: '19.19%',
        y1: '0%',
        x2: '45.32%',
        gradientTransform: 'rotate(-10)',
      },
    ]
    return { themes }
  },
})
